import { render, staticRenderFns } from "./TNC.vue?vue&type=template&id=180ac080"
import script from "./TNC.vue?vue&type=script&lang=js"
export * from "./TNC.vue?vue&type=script&lang=js"
import style0 from "./TNC.vue?vue&type=style&index=0&id=180ac080&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports